import React from "react";
const AgendaHeader = (props) => {
    
    return (
        <React.Fragment>
            <div className="w-full agendaHeader bg-[#2e13ad] pb-[6rem]">
                <div className="flex flex-col custom-breakpoint-container text-white items-center">
                    <p className="text-[2rem] leading-[2.4rem] mt-[5.4rem] mb-[4.5rem] bg-[#C432F0] py-[1rem] px-[3.5rem] rounded-full">
                        SEPT 27 - 28, 2022 • IN PERSON
                    </p>
                    <p className="text-[36px] leading-[43px] text-center mb-[3.1rem]">
                        Personalize your Intel Innovation 2022 <br></br>Conference Experience
                    </p>
                    <p className="text-[28px] leading-[34px] text-center">
                        Click the time slots to add sessions to you agenda
                    </p>
                </div>
            </div>
            
        </React.Fragment>
    )
}
export default AgendaHeader;